module.exports = __webpack_public_path__ + "static/media/generic-ads-list-blurred.0cf9d24e.png";